// @owners { team: patients }
import { type ReduxStateShared } from '~shared/store';

export const getIsCartShowing = (state: ReduxStateShared) => state.ui.cart.isShowing;
